<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="m-portlet m-portlet--tab">
          <div class="m-portlet__body">
            <div>
              <span class="loading-request" v-show="loading"></span>
              <div
                class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2 mb-4 border-bottom"
              >
                <h1 class="h2">Descontos</h1>
                <div class="btn-toolbar mb-2 mb-md-0">
                  <div class="btn-group btn-group-sm" role="group" aria-label="Menu dos Descontos">
                    <span
                      class="btn btn-outline-brand"
                      @click="openNewDiscount('add')"
                      v-b-tooltip.hover
                      title="Novo Desconto!"
                    >
                      <i class="fas fa-plus-square"></i>&nbsp; Cadastrar
                    </span>
                  </div>
                </div>
              </div>
              <div class="page-amounts">
                <nav aria-label="...">
                  <ul class="pagination pagination-md">
                    <li class="page-item" :class="{ selected: amount === 3 }">
                      <a @click="amount = 3" class="page-link paginate">3</a>
                    </li>
                    <li class="page-item" :class="{ selected: amount === 10 }">
                      <a @click="amount = 10" class="page-link paginate">10</a>
                    </li>
                    <li class="page-item" :class="{ selected: amount === 50 }">
                      <a @click="amount = 50" class="page-link paginate">50</a>
                    </li>
                    <li class="page-item" :class="{ selected: amount === 100 }">
                      <a @click="amount = 100" class="page-link paginate">100</a>
                    </li>
                    <li class="page-item" :class="{ selected: amount === 150 }">
                      <a @click="amount = 150" class="page-link paginate">150</a>
                    </li>
                  </ul>
                </nav>
              </div>
              <div class="paginator-info-top m-2">
                <span class="m--font-gray" v-if="data.from"
                  >Exibindo itens de {{ data.from }} a {{ data.to }}, de um total de
                  {{ data.total }}.</span
                >
                <span class="m--font-gray" v-else>Nenhum item a ser exibido.</span>
              </div>
            </div>
            <div class="table-responsive">
              <div class="container-table">
                <table class="table table-striped- table-bordered table-hover table-checkable">
                  <thead>
                    <tr>
                      <td
                        nowrap
                        class="text-center align-middle pointer"
                        width="60"
                        :class="{ 'table-sorted': sortType === 'customer_id' }"
                        @click="sortCall('customer_id')"
                      >
                        ID Cliente
                        <span
                          class="fas fa-caret-down sorted"
                          v-if="sortType === 'customer_id' && !sortReverse"
                        ></span>
                        <span
                          class="fas fa-caret-up sorted"
                          v-if="sortType === 'customer_id' && sortReverse"
                        ></span>
                        <span class="fal fa-sort sort" v-if="sortType !== 'customer_id'"></span>
                      </td>
                      <td nowrap class="text-center align-middle" width="300">Cliente</td>
                      <td nowrap class="text-center align-middle" width="50">Quantidade</td>
                      <td nowrap class="text-center align-middle" width="30"></td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input"
                          @keypress="validateValueNumber"
                          @input="callData"
                          v-model="filters.id"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input"
                          @input="callData"
                          v-model="filters.name"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input"
                          @keypress="validateValueNumber"
                          @input="callData"
                          v-model="filters.quantity"
                        />
                      </td>
                      <td></td>
                    </tr>
                    <tr v-for="(discount, id) in data.data" :key="id">
                      <td class="text-center align-middle">{{ discount.customer_id }}</td>
                      <td class="text-left align-middle">
                        {{ discount.customer.customerable.co_name }}
                      </td>
                      <td class="text-center align-middle">{{ discount.quantity }}</td>
                      <td class="text-center align-middle">
                        <div class="btn-group btn-group-sm btn-collapse-discount" role="group">
                          <span
                            class="btn btn-outline-brand btn-collapse"
                            @click="
                              openCompanyDiscount(
                                discount.customer_id,
                                discount.customer.customerable.co_name
                              )
                            "
                            v-b-tooltip.hover
                            :title="`Descontos de ${discount.customer.customerable.co_name}`"
                          >
                            <i class="fas fa-plus-square"></i>&nbsp;
                          </span>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div>
              <div class="paginator-info-bottom mt-2">
                <span class="m--font-gray" v-if="data.from"
                  >Exibindo itens de {{ data.from }} a {{ data.to }}, de um total de
                  {{ data.total }}.</span
                >
                <span class="m--font-gray" v-else>Nenhum item a ser exibido.</span>
              </div>
              <div class="paginator-list">
                <nav aria-label="...">
                  <ul class="pagination pagination-md">
                    <li class="page-item" :class="{ disabled: data.current_page === 1 }">
                      <a class="page-link paginate" @click="page = 1"
                        ><i class="fal fa-angle-double-left"></i
                      ></a>
                    </li>
                    <li class="page-item" :class="{ disabled: data.current_page === 1 }">
                      <a class="page-link paginate" @click="page = data.current_page - 1"
                        ><i class="fal fa-angle-left"></i
                      ></a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page === 1 }"
                      v-if="data.current_page > 2"
                    >
                      <a class="page-link paginate" @click="page = data.current_page - 2">
                        {{ data.current_page - 2 }}</a
                      >
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page === 1 }"
                      v-if="data.current_page > 1"
                    >
                      <a class="page-link paginate" @click="page = data.current_page - 1">
                        {{ data.current_page - 1 }}</a
                      >
                    </li>
                    <li class="page-item selected">
                      <a class="page-link paginate"> {{ data.current_page }} </a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page === data.last_page }"
                      v-if="data.current_page < data.last_page"
                    >
                      <a class="page-link paginate" @click="page = data.current_page + 1">
                        {{ data.current_page + 1 }}
                      </a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page + 1 === data.last_page }"
                      v-if="data.current_page + 1 < data.last_page"
                    >
                      <a class="page-link paginate" @click="page = data.current_page + 2">
                        {{ data.current_page + 2 }}
                      </a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page === data.last_page }"
                    >
                      <a class="page-link paginate" @click="page = data.current_page + 1"
                        ><i class="fal fa-angle-right"></i
                      ></a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page === data.last_page }"
                    >
                      <a class="page-link paginate" @click="page = data.last_page"
                        ><i class="fal fa-angle-double-right"></i
                      ></a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
            <div class="pt-4"></div>
          </div>
        </div>
      </div>
      <transition name="slideleft" mode="out-in">
        <DiscountModal v-if="showCreateDiscount" @updateList="callData" />
      </transition>
      <transition name="fade" mode="out-in">
        <div
          class="m-quick-sidebar-overlay"
          v-if="showCreateDiscount"
          @click="closeNewDiscount()"
        ></div>
      </transition>

      <transition name="slideleft" mode="out-in">
        <DiscountCompanyModal
          v-if="showCompanyDiscount"
          @updateList="callData"
          :discountName="currentCompanyDiscountName"
        />
      </transition>
      <transition name="fade" mode="out-in">
        <div
          class="m-quick-sidebar-overlay"
          v-if="showCompanyDiscount"
          @click="closeCompanyDiscount()"
        ></div>
      </transition>
    </div>
  </div>
</template>

<script>
import DiscountModal from '@/components/discount/DiscountModal';
import DiscountCompanyModal from '@/components/discount/DiscountCompanyModal';
import { returnMessageMixin } from '@/mixins/returnMessageMixin';
import { validationFilterValueMixin } from '@/mixins/validationFilterValueMixin.js';

import { baseApiUrl } from '@/global';
import axios from 'axios';

export default {
  mixins: [returnMessageMixin, validationFilterValueMixin],
  name: 'Discount',
  components: { DiscountModal, DiscountCompanyModal },
  data() {
    return {
      currentCompanyDiscountName: '',
      data: {},
      sortType: localStorage.customerDiscountSortType
        ? localStorage.customerDiscountSortType
        : 'id',
      sortReverse: localStorage.customerDiscountSortReverse
        ? localStorage.customerDiscountSortReverse
        : false,
      amount: localStorage.customerDiscountDataAmount
        ? localStorage.customerDiscountDataAmount
        : 100,
      page: localStorage.customerDiscountDataPage ? localStorage.customerDiscountDataPage : 1,
      filters: {
        id: localStorage.customerDiscountFilterId ? localStorage.customerDiscountFilterId : '',
        name: localStorage.customerDiscountFilterName
          ? localStorage.customerDiscountFilterName
          : '',
        quantity: localStorage.customerDiscountFilterQuantity
          ? localStorage.customerDiscountFilterQuantity
          : '',
      },
    };
  },
  computed: {
    loading() {
      return !this.data.current_page;
    },
    showCreateDiscount() {
      return this.$store.state.showCreateDiscount;
    },
    showCompanyDiscount() {
      return this.$store.state.showCompanyDiscount;
    },
  },
  methods: {
    changeStatus(customerId) {
      const url = `${baseApiUrl}/v1/customer/status/${customerId}`;
      axios(url)
        .then((res) => {
          this.logMessage(res);
          this.getDatas();
        })
        .catch((error) => {
          this.logMessageFailed(error.response);
        });
      this.callData();
    },
    setFilter(filterToChange, id) {
      this.filters[filterToChange] = id;
      this.callData();
    },
    clearFilters() {
      this.filters.id = '';
      this.filters.name = '';
      this.filters.quantity = '';
      this.filters.sortType = 'name';
      this.filters.sortReverse = false;
      this.callData();
    },
    setStorageFilters() {
      localStorage.setItem('customerDiscountFilterId', this.filters.id);
      localStorage.setItem('customerDiscountFilterName', this.filters.name);
      localStorage.setItem('customerDiscountFilterQuantity', this.filters.quantity);
      localStorage.setItem('customerDiscountDataAmount', this.amount);
      localStorage.setItem('customerDiscountDataPage', this.page);
      localStorage.setItem('customerDiscountSortType', this.sortType);
      localStorage.setItem('customerDiscountSortReverse', this.sortReverse);
    },
    convertFilters() {
      const filters = `?page=${this.page ? this.page : 1}&id=${
        this.filters.id ? this.filters.id : ''
      }&name=${this.filters.name ? this.filters.name : ''}&quantity=${
        this.filters.quantity ? this.filters.quantity : ''
      }&sortType=${this.sortType}&sortOrder=${this.sortReverse ? 'DESC' : 'ASC'}`;
      return filters;
    },
    sortCall(sortType) {
      this.sortReverse = this.sortType === sortType ? !this.sortReverse : false;
      this.sortType = sortType;
    },
    callData() {
      const timeWindow = 700;
      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(() => {
        this.data.current_page = null;
        this.setStorageFilters();
        this.getDatas();
      }, timeWindow);
    },
    getDatas() {
      this.getCustomersWithDiscounts();
    },
    openNewDiscount() {
      this.$store.state.showCreateDiscount = 'add';
    },
    closeNewDiscount() {
      this.$store.state.showCreateDiscount = null;
      this.callData();
    },
    openCompanyDiscount(id, companyName) {
      this.$store.state.showCompanyDiscount = id;
      this.currentCompanyDiscountName = companyName;
    },
    closeCompanyDiscount() {
      this.$store.state.showCompanyDiscount = null;
      this.callData();
    },
    getCustomersWithDiscounts() {
      const url = `${baseApiUrl}/v1/customer/discounts${this.convertFilters()}`;

      axios
        .get(url)
        .then((res) => {
          this.data = res.data;
        })
        .catch((error) => {
          this.logMessageFailed(error.response);
        });
    },
  },
  watch: {
    amount() {
      if (this.page === 1) {
        this.callData();
      } else {
        this.page = 1;
      }
    },
    page() {
      this.callData();
    },
    sortType() {
      this.callData();
    },
    sortReverse() {
      this.callData();
    },
  },
  mounted() {
    this.getDatas();
    window.scroll(0, 0);
  },
};
</script>
